module.exports = __webpack_public_path__ + "img/002.3f9a36b1.svg";